const DEFAULT_PAGE_SIZE = 20;

const ORG_SIZE_DEFAULT_MIN = {
  text: '1',
  value: 0,
};

const ORG_SIZE_DEFAULT_MAX = {
  text: '10,000+',
  value: 9,
};

const SLIDER_STEPS = {
  0: ORG_SIZE_DEFAULT_MIN.text,
  1: '5',
  2: '25',
  3: '50',
  4: '100',
  5: '250',
  6: '500',
  7: '1000',
  8: '10,000',
  9: ORG_SIZE_DEFAULT_MAX.text,
};

export {
  DEFAULT_PAGE_SIZE,
  SLIDER_STEPS,
  ORG_SIZE_DEFAULT_MIN,
  ORG_SIZE_DEFAULT_MAX,
};
